export const colorScheme = {
  dark: {
    background: "#252525",
    primary: "#31E1F7",
    secondary: "#1B1B1B",
    font: "#fff",
  },
  light: {},
};
